import { isSP, qs } from '../common/utils'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Sec8_Environment {
  constructor() {
    
    this.el = qs('.p-top-environment')
    if(!this.el) return
    
    this.bgSetting()
  }
  
  bgSetting()
  {
    const bg = qs('.p-top-environment__bg')
    
    const val1 = isSP() ? 40 : 40
    const val2 = isSP() ? -40 : -40
    
    gsap.fromTo(bg, 
      { yPercent:val1 },
      {
        yPercent:val2,
        duration: 1, 
        ease: "linear",
        
        scrollTrigger: {
          trigger : this.el,
          start   : "top bottom",
          end     : "bottom top",
          scrub   : true,
          // markers : true,
        }
    })
    
    
    const io = new IntersectionObserver( entries =>
    {
      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
          this.el.classList.add("is-inview")
        }
        else
        {
          this.el.classList.remove("is-inview")
        }
      })
    }, {
      rootMargin: '0% 0%',
      threshold: 0
    })

    io.observe(this.el)
  }
}
